<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <b-card >
            <div class="groups">
                <div class="buttons">
                    <b-button title="Ekle" variant="primary" @click="openModal(true,'add')">{{$t('general.add')}} </b-button>
                </div>
                <b-form inline class="formBox"> 
                    <div  class="inputGrp" >
                        <b-table-simple hover responsive>
                            <b-thead>
                                <b-th>{{$t('defination.stockMovementType.list.description')}}</b-th>
                                <b-th>{{$t('defination.stockMovementType.list.stock_movement_type')}}</b-th>
                                <b-th> </b-th>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="item in list" :key="item.ID">
                                    <b-td> {{item.Description}}</b-td>
                                    <b-td> 
                                        <b-badge :variant="item.Type == 'in' || item.Type == 'fault-in' ? 'primary' : 'danger' ">
                                            {{
                                                item.Type=== "in" ?  $t('defination.stockMovementType.list.type_in') : 
                                                    item.Type==="out" ? $t('defination.stockMovementType.list.type_out') : 
                                                    item.Type==="fault-in" ? $t('defination.stockMovementType.list.fault_in') : 
                                                    item.Type==="fault-out" ? $t('defination.stockMovementType.list.fault_out') : ''
                                            }}
                                        </b-badge>
                                    </b-td>
                                    <b-td> 
                                        <div class="buttons">
                                            <b-button size="sm" :title="$t('general.edit')" variant="success" > <b-icon icon="pen-fill" aria-hidden="true" @click="openModal(true,'edit',item)"></b-icon> </b-button>
                                            <b-button size="sm" :title="$t('general.delete')" variant="danger" > <b-icon icon="trash" aria-hidden="true" @click="openModal(true,'delete',item)"></b-icon> </b-button>
                                        </div>
                                   </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                   
                </b-form>
            </div>
        </b-card>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';
    import Modals from './modals/';


    let breadCrumb = [
        { label: i18n.t('pages.defination.name'), url: "/Defination" },
        { label: i18n.t('pages.defination.stockMovementType'), url: "/Defination/StockMovementType" },
    ]
    export default {
        name: "StockMovementType",
        data: function(){
            return{
                breadCrumb,
                modalOpen: false,
                modalProps: {},
                currentForm:"StockMovementType",
                modalName: "",
            }
        },
        components:{
            BreadCrumb, Modals
        },
        async created(){
            await this.$store.dispatch("listStockMovementTypes")
        },
        computed: {
            list() {
                return this.$store.getters.getStockMovementTypes;
            },
        },
        methods:{
            openModal: function(state, modal, props){
                this.modalOpen = state;
                this.modalProps = props;
                this.modalName = modal;
            },
        }
    }
</script>

<style lang="css" scoped > 
    @import "./styles/signalGroups.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/StockMovementType.vue